<template>
	<div class="home">
		<div class="header">
			<div class="container">
				<div class="flex">
					<div class="logo"><img src="../image/zsdb_logo.png" class="logoImg" style="width:132px"></div>
					<div class="menu" id="nav">
						<ul>
							<li class="menulist"><a class="on">首页</a></li>
							<li class="menulist"><a @click="gotoRecruit()" class="">招聘公告</a></li>
							<li class="menulist"><a @click="gotoCampus()" class="">校园招聘</a></li>
							<li class="menulist"><a @click="gotoSociety()" class="">社会招聘</a></li>
							<!-- <li class="menulist"><a @click="gotoIntern()" class="">实习生招聘</a></li> -->
						</ul>
					</div>
					<div class="user">
						<div v-show="islogin" class="isLogin" style="display: none;">
							<div @click="gotopersonal()" style="cursor: pointer;"><span>个人中心</span></div>
							<span class="divider">|</span>
							<div @click="exit()" style="cursor: pointer;"><span> 退出</span></div>
						</div>
						<div v-show="unlogin" class="unLogin" style="display: none;">
							<div @click="gotologin()" style="cursor: pointer;"><span>登录</span></div>
							<span class="divider">|</span>
							<div @click="gotoregister()" style="cursor: pointer;"><span>注册</span></div>
						</div>
					</div>
					<el-popover class="ewm" trigger="hover" placement="bottom">
						<img src="../image/ewm.jpg" class="code">
						<img src="../image/icoewm.png" slot="reference" class="ico">
					</el-popover>

				</div>
			</div>
		</div>
		<div class="indexBanner">
			<video muted="" preload x5-video-player-type="h5-page" x-webkit-airplay="true" webkit-playsinline="true"
				playsinline="true" src="../video/homeVideo.mp4" autoplay="" loop="" class="mp4" id="mp4"
				style="width: 100%;">
			</video>
			<div class="con">
				<el-button class="go_campus" @click="gotoCampus()">查看校园招聘岗位</el-button>
				<el-button class="go_siciety" @click="gotoSociety()">查看社会招聘岗位</el-button>
			</div>
			<div class="shubiao">
				<a @click="shubiao()" id="xiala">
					<img src="../image/shubiao.png" class="ico1">
					<img src="../image/xiala.png" class="ico2">
				</a>
			</div>
		</div>
		<div class="index02" id="index2Ref">
			<div class="lineAreaL">
				<div class="line-group lt">
					<div class="line delay-100"></div>
					<div class="line"></div>
					<div class="line delay-200"></div>
				</div>
			</div>
			<div class="lineAreaR">
				<div class="line-group rb">
					<div class="line"></div>
					<div class="line delay-100"></div>
					<div class="line"></div>
				</div>
			</div>
			<div class="indextitle  wow fadeInUp">
				<img src="../image/yh.png" class="yh">
				<div class="right">
					<h3><span>公司简介</span></h3>
					<p>About Us</p>
				</div>
			</div>
			<div class="container">
				<img src="../image/introduce.jpg" class="imgbg">
				<div class="con  wow fadeInUp" style="margin-top: 35px;">
					<h3>&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp中水东北勘测设计研究有限责任公司</h3>
					<div class="text">
						<span>
							&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp中水东北勘测设计研究有限责任公司（简称中水东北公司）前身是水利部东北勘测设计研究院，
							由1948年成立的丰满水电站筹委会、东北水电工程公司、长春水力发电设计院逐步演变发展而成，先后隶属水利电力部，水利部能源部，水利部。
							2002年转制，成为由水利部水利水电规划设计总院控股，水利部松辽水利委员会、水利部机关服务局参股的有限责任公司，
							水利部寒区工程技术研究中心依托我公司成立。
							<br />&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
							中水东北公司拥有水利、电力、建筑、环境工程设计及工程勘察、监理、咨询等多项高等级资质及工程测绘、地质灾害治理工程勘察、
							建设项目水资源论证等专项甲级资格，完成国内外水利水电勘察、设计、咨询、监理以及工程总承包等大、中型项目400余项。
							<br />&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
							半个多世纪以来，中水东北公司从白山黑水启程，与新中国水利水电事业发展同步，业务范围遍及国内大部分省区，
							与多个国家和地区开展了国际技术交流与项目合作。从中国第一座三心圆混凝土重力拱坝白山水电站，
							到中国严寒地区牡丹江莲花第一座混凝土面板堆石坝；从北方封冻河流上的第一座大顶子山航电枢纽到青藏高原旁多、
							满拉水利枢纽工程；从“中国水电之母”丰满水电站再获新生到西辽河流域引绰济辽工程全面落地；
							从嫩江第一座控制性水利枢纽尼尔基到桂粤澳三地人民的世纪梦想广西大藤峡水利枢纽工程，几代东勘人用脚步丈量出梦想的轨迹。
							公司先后与前苏联、美国、加拿大、日本、德国、土耳其、缅甸、巴基斯坦、蒙古国、
							赞比亚等30多个国家和地区开展了国际技术交流与项目合作。近年来，公司聚焦国家能源发展战略，在抽水蓄能电站、风电场设计、
							光伏发电项目以及工程总承包领域取得骄人业绩。
							<br />&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
							 一分耕耘，一分收获。中水东北公司厚积薄发,汇聚了一份份闪亮的创新成果，拥有深水厚覆盖大型岩塞爆破、
							 寒区面板堆石坝设计等优势技术20余项，荣获国家、省部级金奖、银奖等各种奖励340余项，主参编国家标准、
							 行业标准100余项，获发明专 利20余项、实用新型专 利60余项、计算机软件著作权50余项，在中国水利水电勘察设计领域，
							 尤其在寒区工程领域具有卓越的技术能力和设计水平。被授予全国文明单位、全国水利水电勘测设计行业信用评价高等级企业、
							 国家高 新技术企业等荣誉称号。
							 <br />&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
							 新时代，新征程。中水东北公司将深入贯彻习近平生态文明思想，践行“质量为本、顾客至上；竭诚服务、
							 创新发展”“绿色设计，预防污染；以人为本，健康安全；诚信守法，持续改善”质量环安方针，积极参与谋划清洁低碳、
							 安全高效的新型能源体系建设，发挥长期从事抽水蓄能电站工程设计的技术优势，抢抓风电、光伏等新能源项目发展机遇，
							 助力“碳达峰、碳中和”目标实现，努力为经济社会发展做出更大贡献。
						</span>
					</div>
					<div @click="gotoWebsite()" class="more">了解更多</div>
				</div>
			</div>
		</div>
		<div class="footer">
			<div class="container">
				<p>&copy 2022 Inc. All Rights Reserved. 中水东北勘测设计研究有限责任公司 版权所有 吉ICP备2022003947号-1
					技术支持：中水东北勘测设计研究有限责任公司数字与智慧工程院
					<br />吉公网安备 22010402001082号
				</p>
			</div>
		</div>
		<backtop></backtop>
	</div>
</template>

<script>
	import backtop from "../components/backtop.vue"
	// import footer from "../components/footer.vue"
	import {
		loginstatus,
		Logout,
	} from '../api/user.js'
	// @ is an alias to /src
	export default {
		components: {
			backtop,
			// footer,
		},

		data() {
			return {
				list: [],
				islogin: false,
				unlogin: false,
			}
		},

		mounted() {
			loginstatus().then((res) => {
				if (res.code == 200) {
					this.islogin = true;
					this.unlogin = false;
				} else if (res.code != 200) {
					this.islogin = false;
					this.unlogin = true;
				}
			})
		},

		methods: {
			gotoWebsite() {
				window.open('https://www.neidri.com.cn/')
			},
			exit() {
				Logout().then((res) => {
					location.reload()
				})
			},
			// gotoHome() {
			// 	this.$router.push('/')
			// },
			gotoAboutus() {
				this.$router.push('/aboutus/introduce')
			},
			gotoRecruit() {
				this.$router.push('/recruitInfoList')
			},
			gotoCampus() {
				this.$router.push('/campus')
			},
			gotoSociety() {
				this.$router.push('/society')
			},
			gotoIntern() {
				this.$router.push('/intern')
			},
			gotologin() {
				this.$router.push('/login')
			},
			gotoregister() {
				this.$router.push('/register')
			},
			shubiao() {
				this.$nextTick(() => {
					var top = document.getElementById("index2Ref")
					window.scrollTo({
						top: top.offsetTop,
						behavior: 'smooth'
					});
				});
			},
			gotopersonal() {
				this.$router.push('/personal/resume')
			},
		}
	}
</script>

<style scoped>
	@import url(../assets/css/index.css);

	.unLogin,
	.isLogin {
		display: flex;
	}

	.text {
		width: 1200px;
	}

	.more {
		margin-left: 45% !important;
	}

	.go_campus {
		height: 65px;
		font-size: 18px;
		border: 2px solid #fff;
		background: rgba(255, 255, 255, 0.6);
		border-radius: 40px;
		color: #0056b1;
	}

	.go_siciety {
		height: 65px;
		margin-left: 35px !important;
		font-size: 18px;
		border: 2px solid #fff;
		background: rgba(255, 255, 255, 0.6);
		border-radius: 40px;
		color: #0056b1;
	}
</style>
